<template>
  <div class="filter-color">
    <div
      class="filter-color-center"
      :class="{
        'color-block': colorType == 'block',
        'color-list': colorType == 'list',
      }"
      ref="filterColor"
    >
      <el-checkbox-group
        v-model="checkList"
        @change="change"
        ref="checkboxGroup"
      >
        <template v-for="(item, index) in valueList">
          <el-checkbox
            v-show="index <= showLength - 1"
            :key="(item.name || item.attribute_value) + item.id + index"
            :label="item.id + ''"
            :data-value="
              item.block_value && item.block_value.length
                ? item.block_value.length == 1|| item.display_style == 'color_style_one'
                  ? item.block_value[0]
                  : item.block_value.join(',')
                : item.attribute_value || item.name
            "
          >
            <span class="inline" style="white-space: initial">
              {{ item.attribute_value || item.name }}
            </span>
            <span
              v-show="
                colorType == 'block' &&
                item.block_value &&
                item.block_value.length == 2 &&
                item.display_style == 'color_style_two' &&
                item.block_value[1]!=null
              "
              class="half-circle"
            >
            </span>
            <span
              v-if="colorType == 'list' && filterItem.count_display"
              class="half-circle"
              style="float: right"
            >
              ({{ item.filter_count || item.product_count || "0" }})
            </span>
          </el-checkbox>
        </template>
      </el-checkbox-group>
    </div>
    <v-filterMore
      :payload_num="showLength"
      :max_num="valueList.length"
      :click_method="show_more"
    ></v-filterMore>
  </div>
</template>
<script>
import vFilterMore from "./fillterMore";
export default {
  props: ["filterItem", "payload", "payload_key"],
  data() {
    return {
      checkList: [],
      valueList: [],
      showLength: 5,
      colorType: "", //色卡的显示类型
    };
  },
  methods: {
    show_more() {
      this.showLength = this.valueList.length;
    },

    change(e) {
      let payload = {
        [this.payload_key]: e,
      };
      this.bus.$emit("changeFilter", payload);
    },
    color_render() {
      let checkbox__inner = this.$(this.$refs.checkboxGroup.$el).find(
        ".el-checkbox__inner"
      );
      this.colorType = this.filterItem.method;
      if (
        this.colorType == "block" &&
        checkbox__inner &&
        checkbox__inner.length
      ) {
        let _this = this;
        this.showLength = 15;
        checkbox__inner.each(function () {
          let this_ele = _this.$(this);
          let checkbox__input = this_ele.parent();
          let label = checkbox__input.parent();
          let color = label.attr("data-value").split(",");
          if (
            color[0].toLocaleLowerCase() == "white" ||
            color[0] == "#ffffff"
          ) {
            label.attr("data-white", "white");
          }
          let halfCircle = checkbox__input.next().children(".half-circle");
          if (color.length == 2 && halfCircle) {
            halfCircle.css({ "background-color": color[1].replace(" ", "") });
          }
          this_ele.css({ "background-color": color[0].replace(" ", "") });
        });
      }
    },
  },
  watch: {
    filterItem: {
      handler(newV) {
        let { type, attribute, taxonomy, method } = newV;
        if ((type == "size" || type == "color") && attribute && attribute.length ) {
          this.valueList = attribute;
        } else if (type == "tag" && taxonomy.length) {
          this.valueList = taxonomy;
        }else{
          this.valueList = [];
        }
        this.colorType = method;
        if (method == "block") {
          this.$nextTick(this.color_render);
        }
      },
      immediate: true,
    },
    payload: {
      handler(newV) {
        this.checkList = newV;
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    vFilterMore,
  },
};
</script>
<style scoped lang='scss'>
.filter-color {
  text-align: left;
  font-family: "Muli";
  .color-list {
    & ::v-deep .el-checkbox-group {
      label {
        display: flex;
        width: 100%;
        margin-right: 0;
        align-items: flex-start;
        font-family: "Muli";
        margin-bottom: 10px;
        &:hover {
          opacity: 0.7;
        }
        .el-checkbox__label {
          flex: 1;
          display: flex;
          color: #606266;
          justify-content: space-between;
          line-height: 24px;
          font-size: 13px;
        }
        .el-checkbox__input {
          padding-top: 3px;
          .el-checkbox__inner {
            border-color: #dcdfe6 !important;
            width: 18px;
            height: 18px;
            &::after {
              left: 6px;
              top: 3px;
            }
          }
        }
        &.is-checked .el-checkbox__input {
          .el-checkbox__inner {
            background-color: var(--main-btn-bg) !important;
            color: var(--main-btn-tx) !important;
            border-color: transparent !important;
          }
        }
      }
    }
  }
  .color-block {
    & ::v-deep .el-checkbox-group {
      display: flex;
      flex-wrap: wrap;
      label {
        width: 33.33333%;
        margin-right: 0;
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        font-family: "Muli";
        text-align: center;
        .el-checkbox__input {
          width: 100%;
          .el-checkbox__inner {
            border-radius: 100%;
            border-color: #dcdfe6 !important;
            width: 30px;
            height: 30px;
            background-color: #595959;
            &::after {
              display: none;
            }
          }
        }
        .el-checkbox__input::after {
          content: "";
          position: absolute;
          transform: rotate(45deg) scaleY(0);
          transition: transform 0.15s ease-in 0.05s;
          transform-origin: center;
          border: 2px solid #fff;
          height: 14px;
          border-left: 0;
          border-top: 0;
          top: 18%;
          left: 45%;
          width: 8px;
          z-index: 999;
        }
        .el-checkbox__input.is-checked {
          &::after {
            transform: rotate(45deg) scaleY(1);
          }
          .el-checkbox__inner {
            background-color: #595959;
          }
        }

        .el-checkbox__label {
          width: 100%;
          padding-left: 0;
          line-height: 24px;
          color: black !important;
          font-size: 13px;
        }
      }
      .el-checkbox[data-white="white"] > .el-checkbox__input {
        &::after {
          border-color: black !important;
        }
      }
      .half-circle {
        position: absolute;
        top: 0;
        left: 50%;
        z-index: 9;
        border: 1px solid #dcdfe6 !important;
        width: 15px;
        height: 30px;
        display: inline-block;
        background: transparent;
        transform: rotate(45deg);
        border-radius: 0px 30px 30px 0px;
        transform-origin: left center;
      }
    }
  }
  .inline {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    padding-bottom: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-overflow: -o-ellipsis-lastline;
  }
}
</style>